import styled from 'styled-components';

import { Input } from '@xsolla/ui-core';

export const MultiInputWrapper = styled.div`
  margin-bottom: 16px;
`;

export const AddGroupButton = styled(Input)`
  cursor: pointer;
  margin-bottom: 16px;
  color: transparent;
  text-shadow: 0 0 0 ${(props) => props.theme.colors.brand};
  border: 1px solid rgba(0, 115, 247, 0.32);
  :hover {
    color: transparent;
    text-shadow: 0 0 0 ${(props) => props.theme.colors.brand};
  }
  :focus {
    color: transparent !important;
    text-shadow: 0 0 0 ${(props) => props.theme.colors.brand} !important;
  }
`;
